import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { resizeImage, reformatDate } from "../../shared/utils";
import { AiFillStar } from "react-icons/ai";
import { Link } from "react-router-dom";

const SideFilmItem = ({ item }) => {
  return (
    <Link
      to={item.media_type === "movie" ? `/movie/${item.id}` : `/tv/${item.id}`}
      className="flex gap-5 items-start transiton duration-300 bg-gradient-to-l from-dark-darken to-gray-darken/50 p-3 rounded-md hover:brightness-[1.35] group"
    >
      <div className="shrink-0 max-w-[100px] w-full">
        <LazyLoadImage
          src={resizeImage(item.poster_path, "w154")}
          className="w-full h-full object-cover rounded-md"
          alt="poster"
          effect="blur"
        />
      </div>
      <div className="flex-grow">
        <p className="mb-2 w-full overflow-hidden text-ellipsis-2 text-base text-gray-300 group-hover:text-white group-hover:font-medium transition duration-300">
          {item.title || item.name}
        </p>
        <p className="mb-2 w-full overflow-hidden text-ellipsis text-sm text-gray-400">
          {reformatDate(item.release_date || item.first_air_date)}
        </p>
        <div className="bg-gradient-to-br from-primary to-orange-600 px-2 py-1 rounded-full absolute z-20 flex items-center gap-1 text-white text-xs">
          {item.vote_average?.toFixed(1)}
          <AiFillStar size={15} />
        </div>
      </div>
    </Link>
  );
};

export default SideFilmItem;
